export function preventHistoryRestore() {
  if (!window.history.scrollRestoration) {
    return;
  }
  window.history.scrollRestoration = "manual";
}
